export const formatDoubleDigit = n => n > 9 ? '' + n : '0' + n;